














// vue
import {Vue, Component} from 'vue-property-decorator';
import {Mutation} from 'vuex-class';

// 组件
import HomeStyleOne from './HomeStyleOne.vue';
import LayoutOne from '@/components/layouts/LayoutOne.vue';
import {Toast} from 'vant';

// http
import http from '@/utils/http';
import {homeInfoAPI, companyInfoAPI} from '@/api/index';
import { initWeChatSetting } from '@/router';

@Component({
  components: {
    styleOne: HomeStyleOne,
    layoutOne: LayoutOne,
  },
})
export default class App extends Vue {
  public layoutStyle: string = 'layoutOne';
  public mainStyle: string = 'styleOne';

  @Mutation('setCompanyInfo')
  public setCompanyInfo!: (data: any) => void;

  @Mutation('setNavInfo')
  public setNavInfo!: (data: any) => void;

    // 首页信息
  public homeInfo = {
    cat: [],
    backImgUrl: '',
    backColor: '',
    sortType: 1,
    urlAddr: '',
  };

  // 公司信息
  public companyInfo = {};

  public created() {
    if (process.env.NODE_ENV === 'development') {
      this.setTestData();
    } else {
      this.setUserInfo();
    }
  }

  public mounted() {
    this.getHomeInfo()

    this.getCompanyInfo().finally(() => {
      // 跳转子页面
      const { query } = this.$route;
      const {childPage} = query;

      if (childPage) {
        const parsedChildPage = JSON.parse(childPage as string);

        if (parsedChildPage) {
          this.$router.push(parsedChildPage);
        }
      }

      // 初始化微信
      initWeChatSetting(this.$route);
    });
  }

  // 设置测试数据
  public setTestData(): void {
    const urlData = {
      openid: 'oYKLK1TQ7TMraI4WNv0_fEoaaDLI',
      companyKey: '01',
      headerImg: 'http://thirdwx.qlogo.cn/mmopen/zshZlqTMgm6p8uzUVAZ6VKvBeIDyUaku22AFmMbk5fUrNmOrOianUu4BaPhicQhosWnm5UkAYIiaVXfOm5sibe4OQo2Vmah8nHWZ/132',
      page: null,
      register_openid: 'oYKLK1TQ7TMraI4WNv0_fEoaaDLI',
      localUrl: window.location.origin.concat('/wx-website/#/'),
      isRegister: '1',
      memberCard: '18673056556',
      subscribe: '0',
    };

    window.localStorage.setItem('urlData', JSON.stringify(urlData));
    window.localStorage.setItem('ticket_01', 'jqz2105074c5bdcb35e1f906bdcb');
    window.localStorage.setItem('memberCard', '18673056556');
  }

  // 保存用户信息到本地
  public setUserInfo(): void {
    const query = this.$route.query;

    if ('c' in query) {
      const {
        o,
        c,
        i,
        p,
        m,
        s,
        openid,
        page,
        childPage,
        p1,
        r,
        subscribe,
      } = query;

      const urlData = {
        openid: o,
        companyKey: c,
        headerImg: i || 'http://www.jqzjop.com/ftp_images/01/common/jqz_default_avatar.jpg',
        memberCard: m ? m : null,
        phone: s ? s : null,
        page: page || null,
        register_openid: openid,
        localUrl: window.location.origin.concat('/wx-website/#/'),
        transferPage: 'wx_website', // 登陆后的返回页面
        isRegister: r, // 是否开发注册功能
        subscribe,
      };

      window.localStorage.setItem('urlData', JSON.stringify(urlData));

      if (p1) {
        window.localStorage.setItem(`ticket_${c}`, p1 as string);
      }

      console.log(this.$route);
    }
  }

  // 前往页面
  public toPage(item: any, childId?: string) {
    const {catType, id, outUrl} = item;

    if (outUrl) {
      if ((<string> outUrl).startsWith('http://') || (<string> outUrl).startsWith('https://')) {
        window.location.assign(outUrl);
      } else {
        window.location.assign('http://'.concat(outUrl));
      }

      return false;
    }

    switch (catType) {
      // 根目录
      case '0':
        this.$router.replace({
          path: '/root-col',
          query: {
            data: JSON.stringify(item),
            id: childId ? childId : '0',
          },
        });
        break;
      // 新闻列表
      case '1':
        this.$router.replace({
          path: '/news',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 图文详情
      case '2':
        this.$router.replace({
          path: '/news-article',
          query: {
            data: JSON.stringify(item),
          },
        });
        break;
      // 留言反馈
      case '3':
        this.$router.replace({
          path: '/advise',
        });
        break;
      // 留言反馈
      case '10':
        this.$router.replace({
          path: '/',
        });
        break;
    }
  }

  // 获取首页信息
  public getHomeInfo() {
    return new Promise((resolve, reject) => {
      const body = {};
      const {requestInit} = homeInfoAPI;

      requestInit.body = JSON.stringify(body);

      http(homeInfoAPI).then((data: any) => {
        const {cat, backColor} = data;
        cat.unshift({
          catName: '首页',
          catType: '10',
        });
        this.setNavInfo(cat);
        window.localStorage.setItem('navInfo', JSON.stringify(cat));
        this.homeInfo = data;
        document.body.style.setProperty('--color-theme', backColor);
        resolve(data);
      }).catch((reason) => {
        Toast('首页信息获取失败');
        reject(reason);
      });
    });
  }

  // 获取公司信息
  public getCompanyInfo() {
    return new Promise((resolve, reject) => {
      const body = {};
      const {requestInit} = companyInfoAPI;

      requestInit.body = JSON.stringify(body);

      http(companyInfoAPI).then((data: any) => {
        const {webTitle} = data;
        document.title = webTitle;
        this.setCompanyInfo(data);
        window.localStorage.setItem('companyInfo', JSON.stringify(data));
        resolve(data);
      }).catch((reason) => {
        Toast('公司信息获取失败');
        reject();
      });
    });
  }
}
